<template>
	<div>
        <!-- ------------------------------登入開始------------------------------ -->
         <div class="modal fade cm-modal" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="loginModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header align-middle cm-login-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('login.Title')}}
                            <button type="button" class="close cm-login-close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src="@/assets/images/login-close.png"></span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body cm-login-body">
                        <div v-if="!isQuickDeposit" class="d-none d-md-block cm-login-or">
                            {{$t('login.OR')}}
                        </div>
                        <div class="row">
                            <div v-if="!isQuickDeposit" class="col-md px-4 border-right">
                                <div class="col py-2 text-center font-weight-bold">
                                    {{$t('login.AccountPassword')}}
                                </div>
                                <div class="col py-2 text-center">
                                    <input type="text" class="form-control" name="login.account" v-model="inputAccount" v-on:blur="accountInputMonitor" :placeholder='$t("login.Account")' maxlength="20">
                                    <span class="text-danger" v-if="accountPromptString !== ''">{{accountPromptString}}</span>
                                </div>
                                <div class="col py-2 text-center">
                                    <input type="password" class="form-control" name="login.password" v-model="inputPassword" v-on:blur="passwordInputMonitor" :placeholder='$t("login.Password")' maxlength="20">
                                    <span class="text-danger" v-if="passwordPromptString !== ''">{{passwordPromptString}}</span>
                                </div>
                                <div class="col py-2 text-center">
                                    <div v-if="domControl.isWaitingLoginAll9fun==true" class="spinner-border text-warning text-center my-2" role="status"></div>
                                    <button v-else @click="googleRecaptchaService" type="button" class="btn btn-lg btn-block text-white cm-login-common-btn-color">
                                        {{$t('login.Login')}}
                                    </button>
                                </div>
                                <div class="col py-2 text-center">
                                    <button @click="openRegisterModal" type="button" class="btn btn-lg btn-block text-white cm-login-common-btn-color">{{$t('login.Register')}}</button>
                                </div>
                                <div class="col py-2 text-center">
                                    <a href="#" class="text-center font-weight-bold cm-login-forgotpwd-font-color"
                                        data-toggle="modal" data-target="#forgotPasswordModal">{{$t('login.Forgot')}}</a>
                                </div>
                            </div>
                            <div class="col-md px-4">
                                <div v-if="!isQuickDeposit" class="col py-2 text-center font-weight-bold">
                                    {{$t('login.OtherLoginMethods')}}
                                </div>
                                <div v-if="isQuickDeposit" class="col py-2 text-center font-weight-bold">
                                    {{$t('login.QuickDepositNote')}}
                                    <br/><hr>{{$t('login.SameLoginMethods')}}
                                </div>
                                <div class="col py-2 text-center">
                                    <button @click="facebookAccountLoginService" type="button" class="btn btn-lg btn-block text-white cm-login-facebook-btn-color">{{$t('login.FB')}}</button>
                                </div>
                                <div class="col py-2 text-center">
                                    <button @click="googleAccountLoginService" type="button" class="btn btn-lg btn-block text-white cm-login-google-btn-color">{{$t('login.Google')}}</button>
                                </div>
                                <div class="col py-2 text-center">
                                    <button @click="SignInWithApple" type="button" class="btn btn-lg btn-block text-white cm-login-apple-btn-color">
                                        {{$t('login.Apple')}}
                                    </button>
                                    <button id="appleid-signin" style="display: none"></button>
                                </div>
                                <div class="col py-2 text-center">
                                    <a id="testclick" href="#" data-toggle="modal" data-target="#emailLoginModal" class="btn btn-lg btn-block text-white cm-login-apple-btn-color">
                                        {{$t('login.Email')}}
                                    </a>
                                </div>
                                <!--
                                <img src="@/assets/images/cmi_logo_black.png" class="d-none d-md-block cm-login-img">
                                -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------登入結束------------------------------ -->
	</div>
</template>

<script>
import CookieUtil from "@/assets/js/util/CookieUtil.js";
import ShowMsg from "@/assets/js/util/ShowMsg.js";
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js";
import ValidatorUtil from "@/assets/js/util/ValidatorUtil.js";
import eventBus from '@/assets/js/event/EventBus.js'
import axios from 'axios'
import router from '@/router.js'
import store from "@/store/store-controller/store.js";
import $ from 'jquery'

export default {
    data() {
        return {
            inputAccount: "",
            accountPromptString: "",
            inputPassword: "",
            passwordPromptString: "",
            googleRecaptchaWidget: null,
            autoLoginFlag: false,
            domControl: {
                isWaitingLoginAll9fun: false
            },
            isQuickDeposit: false,
        }
    },
    methods: {
        accountInputMonitor() {
            // 驗證字串長度
            this.accountPromptString = ValidatorUtil.validLength(this.inputAccount, {
                'req': this.$i18n.t('login.Account.Validate.req'),
                'maxLen': this.$i18n.t('login.Account.Validate.maxLen'),
                'minLen': this.$i18n.t('login.Account.Validate.minLen')
            })
            
            if(ValidatorUtil.isLengthMeet(this.inputAccount)) {
                // 驗證字串為英數
                this.accountPromptString = ValidatorUtil.validEngNumOnly(this.inputAccount, {
                    'engNumOnly': this.$i18n.t('login.Account.Validate.engNumOnly')
                })
            }
        },
        passwordInputMonitor() {
            // 驗證字串長度
            this.passwordPromptString = ValidatorUtil.validLength(this.inputPassword, {
                'req': this.$i18n.t('login.Password.Validate.req'),
                'maxLen': this.$i18n.t('login.Password.Validate.maxLen'),
                'minLen': this.$i18n.t('login.Password.Validate.minLen')
            });
            if(ValidatorUtil.isLengthMeet(this.inputPassword)) {
                // 驗證字串為英數
                this.passwordPromptString = ValidatorUtil.validEngNumOnly(this.inputPassword, {
                    'engNumOnly': this.$i18n.t('login.Password.Validate.engNumOnly')
                })
            }
        },
        googleRecaptchaService() {
            // 驗證帳號
            if(this.inputAccount===null || this.inputAccount==="" || this.inputAccount.length<6 || this.inputAccount.length>20) {
                this.accountPromptString = this.$i18n.t('login.Account.Validate.req');
            }
            if(this.inputAccount.length>=6 && this.inputAccount.length<=20) {
                if(!(/^[A-Za-z0-9]+$/.test(this.inputAccount))) {
                    this.accountPromptString = this.$i18n.t('login.Account.Validate.engNumOnly');
                }
            }
            // 驗證密碼
            if(this.inputPassword===null || this.inputPassword==="" || this.inputPassword.length<6 || this.inputPassword.length>20) {
                this.passwordPromptString = this.$i18n.t('login.Password.Validate.req');
            }
            if(this.inputPassword.length>=6 && this.inputPassword.length<=20) {
                if(!(/^[A-Za-z0-9]+$/.test(this.inputPassword))) {
                    this.passwordPromptString = this.$i18n.t('login.Password.Validate.engNumOnly');
                }
            }
            if(this.accountPromptString.length>0 || this.passwordPromptString.length>0) {
                return;
            }
            else {
                if(typeof grecaptcha !== 'undefined') {
                    RecaptchaUtil.startGoogleRecaptchaVerify(process.env.VUE_APP_AUTH_RECAPTCHA_LOGIN, this.loginService);
                }
            }
        },
        async loginService(gRecaptchaResponse) {
            this.domControl.isWaitingLoginAll9fun = true

            const self = this;
            let bodyFormData = new FormData();
            bodyFormData.append("login.account", this.inputAccount);
            bodyFormData.append("login.password", this.inputPassword);
            bodyFormData.append("isMobile", true);
            bodyFormData.append("mydomain", "all9fun.com");
            bodyFormData.append("login.consigneeCode", "@GT");
            if(this.autoLoginFlag == false) {
                bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
            }
            else {
                this.autoLoginFlag = false;
                bodyFormData.append("login.fromLoginPage", false);
            }

            await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/memberLoginAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                if(response.data.result==="success") {
                    CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE, response.data.cookie);
                    CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_ACCOUNT, response.data.account);
                    let lh = window.location.href;                    
                    if (lh.indexOf("quickDeposit") > -1){
                        //簡易儲值不要跳回首頁，留在原頁面就好
                        window.location.reload();                        
                    }else{
                        window.location.href = "/";
                    }
                    
                }
                else if(response.data.result==="forbidLoginGT" || response.data.result==="forbidAllFun") {
                    CookieUtil.logoutAccount();
                    ShowMsg.showModal(self.$i18n.t('login.AccountAndPassword.Backend.ForbiddenMemberService'), {"text-align":"center"});
                }
                else if(response.data.result==="error") {
                    CookieUtil.logoutAccount();
                    alert(self.$i18n.t('login.AccountAndPassword.Backend.notEqu'));
                }
            })
            .catch(function(response) {
                console.log(response);
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
            })
            this.domControl.isWaitingLoginAll9fun = false
        },
        googleAccountLoginService() {
            CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_OPEN_ID_ACTION, "login");
            let googleLoginURL = process.env.VUE_APP_URL_DOMAIN_LOGIN + "/googleLoginWebAction.shtml?mydomain=all9fun.com&request_locale=" + this.$i18n.locale.replace("-", "_");
            let googleLoginWindow = window.open(googleLoginURL, "info","menubar=no,width=1000,height=600,left=100,top=100");
        },
        facebookAccountLoginService() {
            CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_OPEN_ID_ACTION, "login");
            let facebookLoginURL = process.env.VUE_APP_URL_DOMAIN_LOGIN + "/faceBookAction.shtml?mydomain=all9fun.com&request_locale=" + this.$i18n.locale.replace("-", "_");
            let facebookLoginWindow = window.open(facebookLoginURL, "info","menubar=no,width=1000,height=600,left=100,top=100");
        },
        openRegisterModal() {
            document.querySelector('[data-target="#registerModal"]').click()
        },
        isInclude(name){
            var js= /js$/i.test(name);
            var es=document.getElementsByTagName(js?'script':'link');
            for(var i=0;i<es.length;i++) 
            if(es[i][js?'src':'href'].indexOf(name)!=-1)return true;
            return false;
        },
        SignInWithApple()
        {
            var client_Id = process.env.VUE_APP_SIGNINWITHAPPLE_CLIENTID;
            var redirect_URI = process.env.VUE_APP_SIGNINWITHAPPLE_REDIRECTURI;
            if(location.port != "") {
                redirect_URI = redirect_URI + "?p=" + location.port;
            }
            AppleID.auth.init({
                clientId: client_Id,
                scope: 'openid email',
                redirectURI: redirect_URI
            });
            
            AppleID.auth.signIn();
        }
    },
    mounted() {
        const self = this;

        // 玩家註冊成功時
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_AUTO_LOGIN_WHEN_REGISTER_SUCCESS, function(json) {
            if(json.status === "success" && json.account!==undefined && json.password!==undefined) {
                if(json.isFromLoginPage !== undefined &&  json.isFromLoginPage == false) {
                    self.inputAccount = json.account;
                    self.inputPassword = json.password;
                    self.autoLoginFlag = true;
                    self.loginService();
                }
            }
        })
        
        // 更換語言時
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_OPEN_MODAL_LOGIN, function() {
            if(self.accountPromptString != "") self.accountInputMonitor()
            if(self.passwordPromptString != "") self.passwordInputMonitor()
        });
        //簡易儲值隱藏登入與註冊欄位
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , function(isQuickDeposit) {
            self.isQuickDeposit = isQuickDeposit;
        });
    },
    created() {
        // 外部帳號openId登入後導回首頁，因應遊戲官網共用Google、FB帳號登入
        window.onfocus = function() {
	        if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_OPEN_ID_ACTION)=="login_success") {
                CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_OPEN_ID_ACTION, "");
                let lh = window.location.href;
                if (lh.indexOf("quickDeposit") > -1){
                    //簡易儲值不要跳回首頁，留在原頁面就好
                    window.location.reload();                    
                }else{
                    window.location.href = "/";
                }
            }            
        }
    },
}
</script>